var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mt-2",staticStyle:{"scroll-margin-top":"133px"}},[_c('h2',{staticClass:"h4 px-2"},[_vm._v(_vm._s(_vm.title))]),_c('hr'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }